@if (page(); as p) {
  <!-- Hero Header -->
  <header class="lp-hero">
    <div class="container lp-hero__inner">
      <h1 class="lp-hero__title">{{ p.title }}</h1>
      @if (p.lastUpdated) {
        <p class="lp-hero__date">
          <span class="lp-hero__date-label">{{ 'legal.lastUpdated' | translate }}</span>
          {{ p.lastUpdated }}
        </p>
      }
    </div>
  </header>

  <!-- Body: TOC sidebar + content -->
  <div class="container lp-layout">

    <!-- Sticky Table of Contents -->
    <aside class="lp-toc" aria-label="Table of contents">
      <div class="lp-toc__card">
        <h3 class="lp-toc__heading">Contents</h3>
        <nav class="lp-toc__nav">
          @for (section of p.sections; track $index) {
            @if (section.heading) {
              <a
                class="lp-toc__link"
                [href]="'#section-' + $index"
                (click)="scrollTo($event, 'section-' + $index)">
                <span class="lp-toc__dot" aria-hidden="true"></span>
                {{ section.heading }}
              </a>
            }
          }
        </nav>
      </div>
    </aside>

    <!-- Main sections -->
    <main class="lp-content">
      @for (section of p.sections; track $index) {
        <section
          class="lp-section"
          [class.lp-section--intro]="!section.heading"
          [id]="'section-' + $index">

          @if (section.heading) {
            <div class="lp-section__header">
              <span class="lp-section__num-badge" aria-hidden="true">
                <i class="iconsax" [attr.icon-name]="getSectionIcon($index)"></i>
              </span>
              <h2 class="lp-section__heading">{{ section.heading }}</h2>
            </div>
          }

          <div class="lp-section__body">
            @for (para of section.paragraphs; track $index) {
              <p class="lp-section__para">{{ para }}</p>
            }
          </div>

        </section>
      }
    </main>

  </div>
} @else {
  <div class="container lp-not-found">
    <p>{{ 'legal.pageNotFound' | translate }}</p>
  </div>
}
